import { pipep } from "bluebird-promisell";

export const toJson = m => m.toJSON();
export const saveToJson = pipep([m => m.save(), toJson]);
export const fetchToJson = pipep([m => m.fetch(), toJson]);
